export const processClassName = {
  article:
    'lens-process-article box-border max-xl:pt-[64px] bg-[#f4f4f4] xl:bg-[#f8f8f8] xl:flex  xl:h-[100vh] pb-[100px] xl:pb-[87px]',
  leftPart: 'hidden xl:flex w-[44%] 2xl:w-[47%]',
  leftPartSide: 'flex-1 min-w-[48px]',
  leftPartBox:
    'box-border flex-1 basis-[480px] min-w-[480px] xl:max-w-[602px] pr-[3.54vw] flex justify-between items-center',
  leftBottom: 'w-full h-[330px] shrink-0',
  rightPart: 'w-full xl:w-[56%] 2xl:w-[53%] xl:relative overflow-x-hidden',
  rightPartContent: 'flex',
  rightPartBox: 'box-content flex-1 xl:w-[620px] xl:basis-[620px] xl:max-w-[720px] xl:pl-[3.54vw]',
  rightPartSide: 'hidden xl:block flex-1 xl:min-w-[48px]',
};
